/**
 * Converts pounds to kilograms.
 *
 * @param {number} lbs The number to convert.
 */
const lbsToKgs = ( lbs: number ) => lbs * 0.45359237

export default lbsToKgs
